import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/site/Header";
import BeforeAfter from "@/components/site/BeforeAfter";
import Hero from "@/components/site/Hero";
import TickerBar from "@/components/site/TickerBar";
import ReviewsBanner from "@/components/site/ReviewsBanner";
import PhotoQuoteEngine from "@/components/site/PhotoQuoteEngine";
import HowItWorks from "@/components/site/HowItWorks";
import Services from "@/components/site/Services";
import Merch from "@/components/site/Merch";
import ServiceCoverage from "@/components/site/ServiceCoverage";
import Footer from "@/components/site/Footer";
import CartDrawer from "@/components/site/CartDrawer";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 150);
    return () => clearTimeout(t);
  }, [hash]);
  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <TickerBar />
        <ReviewsBanner />
        <PhotoQuoteEngine />
        <HowItWorks />
        <Services />
        <BeforeAfter />
        <Merch limit={3} title="Latest Trending" showViewAll />
        <ServiceCoverage />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
